module.exports = __webpack_public_path__ + "img/logo-simple.d08b93c2.png";